/**
 * 利用状況
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/dashboard/tenant_tasks`

const dashboard_tenant_task = {
  namespaced: true,
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
}
export default dashboard_tenant_task
